"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageVersion = void 0;
// This file is generated by @tableau/module-dev-scripts/src/scripts/compile.ts
// Use this only for good or for awesome.
exports.packageVersion = '9.13.0';
//# sourceMappingURL=VersionInfo.js.map